export const IS_DEV = process.env.NODE_ENV === "development";
export const IS_TEST = process.env.REACT_APP_EXEC_ENV === "test";

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_PROD_API) {
    return "https://rp-api.embedgames.app";
  }

  if (IS_DEV) return "http://localhost:3100";

  if (IS_TEST) return "https://rp-api-test.embedgames.app";

  return "https://rp-api.embedgames.app";
};

export const AppId = "43331ce2-7d16-465c-a10e-6a8b411653ce";

export const CDN_URL = 'https://42394e2c-ffbf-431f-8ce7-000dfe6c3825.selcdn.net';
